import PlanificadorFormularioService from 'src/modules/planificadorFormulario/planificadorFormularioService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';
import listActions from 'src/modules/planificadorFormulario/list/planificadorFormularioListActions';

const prefix = 'PLANIFICADORFORMULARIO_FORM';

const planificadorFormularioFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: planificadorFormularioFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await PlanificadorFormularioService.find(id);
      }

      dispatch({
        type: planificadorFormularioFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: planificadorFormularioFormActions.INIT_ERROR,
      });

      getHistory().push('/planificador-formulario');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: planificadorFormularioFormActions.CREATE_STARTED,
      });

      await PlanificadorFormularioService.create(values);

      dispatch({
        type: planificadorFormularioFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.planificadorFormulario.create.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/planificador-formulario');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: planificadorFormularioFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: planificadorFormularioFormActions.UPDATE_STARTED,
      });

      await PlanificadorFormularioService.update(id, values);

      dispatch({
        type: planificadorFormularioFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.planificadorFormulario.update.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/planificador-formulario');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: planificadorFormularioFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default planificadorFormularioFormActions;
